"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMergeState = useMergeState;
exports.HubToAdditionalUnitsParamKey = exports.filterInvalidAddons = exports.useBundleState = exports.useCalculatorState = exports.useActiveTerm = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _underscore = require("underscore");

var _ActiveTermSelectors = require("pricing-pages-unified-ui/selectors/ActiveTermSelectors");

var _queryParamUtils = require("./queryParamUtils");

var _ActiveTermActions = require("../actions/ActiveTermActions");

var _HubToAddonsMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/HubToAddonsMap"));

var _Hubs = require("self-service-api/constants/Hubs");

var _validators = require("pricing-pages-unified-ui/utils/validators");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _HubToAdditionalUnits;

function useMergeState() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useState = (0, _react.useState)(initialState),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var mergeState = function mergeState(nextState) {
    return setState(function (oldState) {
      return (0, _extends2.default)({}, oldState, nextState);
    });
  };

  return [state, mergeState];
}

var useActiveTerm = function useActiveTerm() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var activeTerm = (0, _reactRedux.useSelector)(_ActiveTermSelectors.activeTermSelector);

  var setActiveTerm = function setActiveTerm(updatedActiveTerm) {
    if (!updatedActiveTerm) return;
    dispatch((0, _ActiveTermActions.updateActiveTerm)(updatedActiveTerm));
  };

  return {
    activeTerm: activeTerm,
    setActiveTerm: setActiveTerm
  };
};

exports.useActiveTerm = useActiveTerm;

var getInitialCalculatorState = function getInitialCalculatorState() {
  var queryParams = (0, _queryParamUtils.getQueryParams)();
  return {
    edition: (0, _validators.validateEditionOrGetDefault)(queryParams.edition),
    contacts: (0, _validators.validateUnitQuantityOrGetDefault)(queryParams.contacts),
    sales_seats: (0, _validators.validateUnitQuantityOrGetDefault)(queryParams.sales_seats),
    service_seats: (0, _validators.validateUnitQuantityOrGetDefault)(queryParams.service_seats),
    addons: (0, _validators.validateAddonsOrGetDefault)(queryParams.addons),
    services: (0, _validators.validateServicesOrGetDefault)(queryParams.services)
  };
};

var useCalculatorState = function useCalculatorState() {
  var _useMergeState = useMergeState(getInitialCalculatorState()),
      _useMergeState2 = (0, _slicedToArray2.default)(_useMergeState, 2),
      state = _useMergeState2[0],
      mergeState = _useMergeState2[1];

  var setState = function setState(updatedState) {
    return mergeState(updatedState);
  };

  return [state, setState];
};

exports.useCalculatorState = useCalculatorState;

var getInitialBundleState = function getInitialBundleState(isInMCBeta) {
  var queryParams = (0, _queryParamUtils.getQueryParams)();
  var defaultMarketingPlan = null;
  var defaultSalesPlan = null;
  var defaultServicePlan = null; // Default to Starter Growth Suite selection if no query params specified

  if ((0, _underscore.isEmpty)(queryParams)) {
    defaultMarketingPlan = isInMCBeta ? _MerchandiseIds.PRODUCT_MARKETING_STARTER_MC : _MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019;
    defaultSalesPlan = _MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020;
    defaultServicePlan = _MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020;
  }

  return {
    marketingPlanSelected: (0, _validators.validateMerchIdOrGetDefault)(queryParams.marketingPlanSelected, _Hubs.HUB_MARKETING, defaultMarketingPlan, isInMCBeta),
    salesPlanSelected: (0, _validators.validateMerchIdOrGetDefault)(queryParams.salesPlanSelected, _Hubs.HUB_SALES, defaultSalesPlan),
    servicePlanSelected: (0, _validators.validateMerchIdOrGetDefault)(queryParams.servicePlanSelected, _Hubs.HUB_SERVICE, defaultServicePlan),
    cmsPlanSelected: (0, _validators.validateMerchIdOrGetDefault)(queryParams.cmsPlanSelected, _Hubs.HUB_CMS),
    marketingUnits: (0, _validators.validateUnitQuantityOrGetDefault)(queryParams.marketingUnits),
    salesUnits: (0, _validators.validateUnitQuantityOrGetDefault)(queryParams.salesUnits),
    serviceUnits: (0, _validators.validateUnitQuantityOrGetDefault)(queryParams.serviceUnits),
    selectedAddOns: (0, _validators.validateAddonsOrGetDefault)(queryParams.selectedAddOns),
    selectedServices: (0, _validators.validateServicesOrGetDefault)(queryParams.selectedServices)
  };
};

var useBundleState = function useBundleState(isInMCBeta) {
  var _useMergeState3 = useMergeState(getInitialBundleState(isInMCBeta)),
      _useMergeState4 = (0, _slicedToArray2.default)(_useMergeState3, 2),
      state = _useMergeState4[0],
      mergeState = _useMergeState4[1];

  var setState = function setState(updatedState) {
    return mergeState(updatedState);
  };

  return [state, setState];
}; // Used to ensure addons that are specific to an edition
// don't get carried over when switching to new edition


exports.useBundleState = useBundleState;

var filterInvalidAddons = function filterInvalidAddons(addons, hub, currentEdition, nextEdition) {
  if (!addons || addons.length === 0) return [];
  var editionSpecificMerchMap = _HubToAddonsMap.default[hub].editionSpecificMerchMap;
  var currentEditionHasUniqueAddons = editionSpecificMerchMap && editionSpecificMerchMap[currentEdition];
  var currentEditionSpecificAddons = currentEditionHasUniqueAddons ? editionSpecificMerchMap[currentEdition] : [];
  var nextEditionHasUniqueAddons = editionSpecificMerchMap && editionSpecificMerchMap[nextEdition];
  var nextEditionSpecificAddons = nextEditionHasUniqueAddons ? editionSpecificMerchMap[nextEdition] : [];
  var invalidAddons = (0, _underscore.difference)(currentEditionSpecificAddons, nextEditionSpecificAddons);
  var filteredAddons = addons.filter(function (addon) {
    return !invalidAddons.includes(addon);
  });
  return filteredAddons;
};

exports.filterInvalidAddons = filterInvalidAddons;
var HubToAdditionalUnitsParamKey = (_HubToAdditionalUnits = {}, (0, _defineProperty2.default)(_HubToAdditionalUnits, _Hubs.HUB_MARKETING, 'contacts'), (0, _defineProperty2.default)(_HubToAdditionalUnits, _Hubs.HUB_SALES, 'sales_seats'), (0, _defineProperty2.default)(_HubToAdditionalUnits, _Hubs.HUB_SERVICE, 'service_seats'), _HubToAdditionalUnits);
exports.HubToAdditionalUnitsParamKey = HubToAdditionalUnitsParamKey;


//////////////////
// WEBPACK FOOTER
// ./js/utils/stateUtils.js
// module id = 77
// module chunks = 5 6 7